// extracted by mini-css-extract-plugin
export var actions = "_1i-0";
export var actionsContainer = "_1i-6";
export var border = "_1i-1";
export var childFullHeight = "_1i-d";
export var collapse = "_1i-2";
export var content = "_1i-8";
export var contentChild = "_1i-c";
export var fullscreen = "_1i-a";
export var headerContainer = "_1i-3";
export var headerRow = "_1i-5";
export var hidePadding = "_1i-9";
export var noScrollX = "_1i-e";
export var noScrollY = "_1i-f";
export var optOutTopPadding = "_1i-b";
export var pagePadding = "_1i-7";
export var profile = "_1i-g";
export var profileContainer = "_1i-h";
export var profileImage = "_1i-i";
export var profileMain = "_1i-j";
export var profileSubtitle = "_1i-l";
export var profileTitle = "_1i-k";
export var tabsWrapper = "_1i-4";
export var title = "_1i-m";